export default __webpack_public_path__ + "reaction-c1a9b44e9c5be2031bde83d0730a7055.mp3";